
export default function Resultados() {
  const results = [
    {
      icon: 'ri-chess-fill',
      title: 'Pensamento Estratégico',
      description: 'Desenvolve visão de longo prazo e capacidade de planejar jogadas vencedoras'
    },
    {
      icon: 'ri-brain-fill',
      title: 'Domina a Inteligência Artificial',
      description: 'Entende e utiliza IA como ferramenta poderosa para criar e inovar'
    },
    {
      icon: 'ri-lightbulb-flash-fill',
      title: 'Mentalidade Empreendedora',
      description: 'Pensa como empreendedor e identifica oportunidades em qualquer situação'
    },
    {
      icon: 'ri-money-dollar-circle-fill',
      title: 'Entende o Jogo do Dinheiro',
      description: 'Compreende como o dinheiro funciona e como criar riqueza de verdade'
    },
    {
      icon: 'ri-shield-star-fill',
      title: 'Acredita em Si Mesmo',
      description: 'Desenvolve autoconfiança inabalável e certeza do seu potencial'
    },
    {
      icon: 'ri-fire-fill',
      title: 'Domina Sua Vontade',
      description: 'Controla impulsos e mantém disciplina para alcançar qualquer objetivo'
    },
    {
      icon: 'ri-bit-coin-fill',
      title: 'Constrói Patrimônio com Bitcoin',
      description: 'Entende criptomoedas e como construir riqueza no mundo digital'
    },
    {
      icon: 'ri-global-fill',
      title: 'Acredita que Pode Mudar o Mundo',
      description: 'Desenvolve visão de impacto e certeza de que pode fazer a diferença'
    }
  ];

  return (
    <section className="relative py-16 md:py-32 overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-neon-blue/5 to-transparent"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 md:gap-16 items-center">
            {/* Content */}
            <div className="space-y-6 md:space-y-8 order-2 lg:order-1">
              <div className="inline-flex items-center gap-2 px-3 md:px-4 py-2 rounded-full bg-neon-blue/10 border border-neon-blue/30 backdrop-blur-sm">
                <i className="ri-trophy-fill text-neon-blue text-sm md:text-base"></i>
                <span className="text-neon-blue text-xs md:text-sm font-semibold tracking-wide">RESULTADOS REAIS</span>
              </div>

              <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight">
                A Transformação Real em 3 Semanas
              </h2>

              <p className="text-base md:text-xl text-gray-300 leading-relaxed">
                Após completar o <strong className="text-white">Freedom Experience</strong>, seu filho terá desenvolvido:
              </p>

              <div className="grid sm:grid-cols-2 gap-3 md:gap-4">
                {results.map((result, index) => (
                  <div 
                    key={index}
                    className="flex items-start gap-3 p-3 md:p-4 bg-dark-800/50 backdrop-blur-sm border border-neon-blue/20 rounded-lg md:rounded-xl hover:border-neon-blue/50 transition-all duration-300 hover:shadow-[0_0_20px_rgba(0,212,255,0.2)]"
                  >
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-neon-blue/10 rounded-lg md:rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className={`${result.icon} text-lg md:text-xl text-neon-blue`}></i>
                    </div>
                    <div>
                      <h3 className="text-white font-bold text-sm md:text-base mb-1">{result.title}</h3>
                      <p className="text-gray-400 text-xs md:text-sm leading-relaxed">{result.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Image */}
            <div className="relative order-1 lg:order-2">
              <div className="relative rounded-2xl md:rounded-3xl overflow-hidden border border-neon-blue/30 shadow-[0_0_40px_rgba(0,212,255,0.3)] md:shadow-[0_0_60px_rgba(0,212,255,0.3)]">
                <img 
                  src="https://readdy.ai/api/search-image?query=dramatic%20before%20and%20after%20transformation%20showing%20young%20student%20evolving%20into%20confident%20successful%20entrepreneur%20leader%20with%20holographic%20success%20symbols%20achievement%20visualization%20and%20growth%20journey%20with%20blue%20and%20purple%20neon%20lighting%20representing%20personal%20development%20business%20skills%20and%20complete%20transformation%20from%20learner%20to%20leader%20in%20inspiring%20futuristic%20environment&width=600&height=800&seq=transformation&orientation=portrait"
                  alt="Transformação de estudante para líder empreendedor"
                  className="w-full h-auto object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-br from-neon-blue/20 via-transparent to-neon-purple/20"></div>
              </div>

              {/* Floating Card */}
              <div className="absolute -bottom-4 md:-bottom-6 left-1/2 -translate-x-1/2 bg-dark-800/90 backdrop-blur-xl border border-neon-blue/40 rounded-xl md:rounded-2xl p-4 md:p-6 shadow-[0_0_30px_rgba(0,212,255,0.4)] md:shadow-[0_0_40px_rgba(0,212,255,0.4)] max-w-[280px] md:max-w-sm">
                <div className="text-center">
                  <p className="text-2xl md:text-3xl font-black text-neon-blue mb-1 md:mb-2">3 Semanas</p>
                  <p className="text-white font-semibold text-sm md:text-base">Transformação Completa</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
